import { push } from 'connected-react-router';
import * as ActionTypes from '../../constants/ActionTypes';
import API from '../../helpers/api';

export function getEquipmentById({ id }) {
	return async (dispatch, getState) => {
		dispatch({
			type: ActionTypes.GET_EQUIPMENT_BASIC_PAGE_REQUEST,
			payload: {
				loading: true,
				hasLoaded: false
			}
		});

		const response = await API.equipment.getEquipmentById({id});
		if (response.meta.code !== 200) {
			return dispatch({
				type: ActionTypes.GET_EQUIPMENT_BASIC_PAGE_ERROR,
				payload: {
					meta: response.meta,
					loading: false
				}
			});
		}

		dispatch({
			type: ActionTypes.GET_EQUIPMENT_BASIC_PAGE_SUCCESS,
			payload: {
				loading: false,
				equipment: response.data.equipment
			}
		});
	};
}

export function onSubmit(fields) {
	return async (dispatch, getState) => {
		const equipment = getState().equipmentDetailPage.basicPageReducer.equipment;

		dispatch({
			type: ActionTypes.SUBMIT_EQUIPMENT_BASIC_PAGE_REQUEST,
			payload: {
				loadingSubmit: true,
				hasLoaded: false
			}
		});

		const body = {
			equipment: {
				name: fields.name,
				slug: fields.slug,
				description: fields.description,
				location_id: fields.location_id,
				status: fields.status,
				type: fields.type,
				...(fields.duration && {duration: fields.duration}),
				channel: fields.channel,
				port: fields.port,
				controller_ip: fields.controller_ip
			}
		};

		let response;
		if (equipment) {
			body.equipment.updated_at = equipment.updated_at;
			response = await API.equipment.updateEquipmentById(equipment._id, body);
		} else {
			response = await API.equipment.createEquipment(body);
		}

		if (response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.SUBMIT_EQUIPMENT_BASIC_PAGE_ERROR,
				payload: {
					meta: response.meta,
					loadingSubmit: false,
					hasLoaded: false
				}
			});
			return;
		};

		const { equipment: newEquipment } = response.data;

		dispatch({
			type: ActionTypes.SUBMIT_EQUIPMENT_BASIC_PAGE_SUCCESS,
			payload: {
				equipment: newEquipment,
				meta: response.meta,
				loadingSubmit: false,
				hasLoaded: true
			}
		});
		if (newEquipment) {
			dispatch(push(`/equipments/id/basic?id=${newEquipment._id}`));
		}
	};
}

export function deleteEquipmentById() {
	return async (dispatch, getState) => {
		const { _id: id } = getState().equipmentDetailPage.basicPageReducer.equipment;

		dispatch({
			type: ActionTypes.DELETE_EQUIPMENT_BASIC_PAGE_REQUEST,
			payload: {
				loadingSubmit: true,
				hasLoaded: false
			}
		});

		const response = await API.equipment.deleteEquipmentById({ id });
		if (response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.DELETE_EQUIPMENT_BASIC_PAGE_ERROR,
				payload: {
					meta: response.meta,
					loadingSubmit: false,
					hasLoaded: false
				}
			});
			return;
		};
		dispatch({
			type: ActionTypes.DELETE_EQUIPMENT_BASIC_PAGE_SUCCESS,
			payload: {
				meta: response.meta,
				loadingSubmit: false,
				hasLoaded: false
			}
		});
		dispatch(push('/equipments'));
	};
}

export function resetMeta() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.RESET_EQUIPMENT_BASIC_PAGE_META
		});
	};
}

export function resetPage() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.RESET_EQUIPMENT_BASIC_PAGE
		});
	};
}
